import { Component, EventEmitter, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { TruckReport, LPGDistService } from '../../lpg-dist.service';
import { Truck, TrucksService } from 'src/app/transportation';
import { forkJoin } from 'rxjs';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { PgTitleComponent, PgDateRangeTitleComponent, PgToolbarComponent, PgDateRangeTitleEnum } from 'src/app/shared/components/title-bar/title-bar.component';
import { DateRange } from 'src/app/shared/components/date-range.component';
import { LpgDistToolbarComponent } from '../../lpg-dist-toolbar/lpg-dist-toolbar.component';
import moment from 'moment-jalaali';
import saveAs from 'file-saver';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
import { PersianDatePipe } from 'src/app/shared/components';

@Component({
  selector: 'app-truck-reports',
  templateUrl: './trucks-reports.component.html',
  imports: [SharedModule, AgGridModule, PersianDatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [LPGDistService, TrucksService]
})
export class TrucksReportsComponent implements OnInit, PgTitleComponent, PgDateRangeTitleComponent, PgToolbarComponent {
  title = new EventEmitter<string>();
  dateRangeSubTitle = new EventEmitter<[DateRange, PgDateRangeTitleEnum]>();
  toolbarComponentType = LpgDistToolbarComponent;
  toolbarComponent!: LpgDistToolbarComponent;

  loadings: TruckReport[] = [];
  organisations: Organisation[] = [];
  trucks: Truck[] = [];
  dateRange: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };

  truckReport?: TruckReport;

  gridOptions: GridOptions = {};

  constructor(
    private lpgDistService: LPGDistService,
    private trucksService: TrucksService,
    private organisationService: OrganisationService,
    private renderer: Renderer2
  ) { }

  columnDefs = [
    { headerName: 'Truck no.', field: 'truckNumber' },
    { headerName: 'Company', field: 'manager' },
    {
      headerName: 'Count',
      cellRenderer: (data: any) =>
        this.countRender(data.data)
    },
  ];

  countRender(data: any) {
    const dataClick = this.renderer.createElement('a');
    this.renderer.addClass(dataClick, 'btn');
    this.renderer.addClass(dataClick, 'btn-link');
    this.renderer.setAttribute(dataClick, 'data-bs-toggle', 'modal');
    this.renderer.setAttribute(dataClick, 'data-bs-target', '#loadingModal');
    const span = this.renderer.createElement('span');
    this.renderer.appendChild(span, this.renderer.createText(data.count));
    this.renderer.appendChild(dataClick, span);
    this.renderer.listen(dataClick, 'click', () => this.truckReport = data);
    return dataClick;
  }

  ngOnInit() {
    this.gridOptions = AgGridService.getOptions();
    const end = moment().endOf('day').toDate();
    this.dateRange = {
      startDate: moment(end).startOf('jMonth').toDate(),
      endDate: end
    };
    forkJoin([
      this.lpgDistService.getTrucksReport(this.dateRange.startDate.getTime(), this.dateRange.endDate.getTime()),
      this.trucksService.get(),
      this.organisationService.get()
    ]).subscribe(results => {
      this.loadings = results[0];
      this.organisations = results[2];
      this.trucks = results[1];
      this.setToolbar();
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  setToolbar() {
    this.title.emit('Trucks loadings');
    this.dateRangeSubTitle.emit([this.dateRange, PgDateRangeTitleEnum.persian]);
    this.toolbarComponent.dateRange = {
      startDate: this.dateRange.startDate,
      endDate: this.dateRange.endDate
    };
    this.toolbarComponent.jalali = true;
    this.toolbarComponent.singleDate = false;
    this.toolbarComponent.itemsSelected.subscribe(t => {
      this.lpgDistService.getTrucksReport(t.dateRange.startDate.getTime(), t.dateRange.endDate.getTime()).subscribe(loadings => {
        this.loadings = loadings;
        this.dateRange = t.dateRange;
        this.dateRangeSubTitle.emit([t.dateRange, PgDateRangeTitleEnum.persian]);
      });
    });
    this.toolbarComponent.excelExport = this.xlsxReport;
  }

  organisationNameFormatter(id: string) {
    if (id) {
      if (id.includes('parsagroup')) {
        return ` گروه پارسا ${this.organisations.find(o => o.name === id)?.nameTranslations['fa']}`;
      } else {
        return this.organisations.find(o => o.name === id)?.nameTranslations['fa'];
      }
    }
  }

  xlsxReport(lpgDistService: LPGDistService, dateRange: DateRange) {
    return lpgDistService
      .getTrucksReportExcel(dateRange.startDate.getTime(), dateRange.endDate.getTime())
      .subscribe(file => {
        saveAs(file.body || '', 'All-trucks-loadings.xlsx');
      });
  }
}
